module.exports = __webpack_public_path__ + "static/media/promo.042a388d.png";